import React, { Component } from 'react'
import ReactDOMServer from 'react-dom/server'
import { Provider } from 'react-redux'
import store from '../store'
import IntlProvider from '../containers/IntlProvider'
import _ from 'lodash'

const normalize = (value) => {
    return _.deburr(_.lowerCase(value))
}

const filterOption = (inputValue, option) => {
    const markup = ReactDOMServer.renderToStaticMarkup(
        <Provider store={store}>
            <IntlProvider>
                {option.props.children}
            </IntlProvider>
        </Provider>
    )
    return _.includes(normalize(markup), normalize(inputValue))
}

export default (WrappedComponent) => {

    return class extends Component {

        render() {
            return <WrappedComponent filterOption={this.props.ajax ? false : filterOption} {...this.props} />
        }

    }

}


// WEBPACK FOOTER //
// ./src/hocs/withFilterOptions.js